export const sortById = (list: any[]) => [...list].sort((a, b) => a.id > b.id ? 1 : -1);

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));